<template>
<div class="chapter">
<div class="inner_page">
<p class="partno"><a id="page_17">I</a></p><a id="page_17">
<p class="parttitle"><b>Collective Consciousness and Community</b></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Part01.vue?62cb5ca2